/**
 * @packageDocumentation
 * Renders the total-win button widget that expands to show cumulative payouts and links into the win popup timeline.
 */
import * as PIXI from "pixi.js"; 
import { Assets } from 'pixi.js'; 
import { font_main } from "./global";
/**
 * Class representing the totalWinting area UI component
 * @extends PIXI.Container
 */
export class TotalWinButton extends PIXI.Container{
    totalWinContainer: any;
    totalwinValueText: PIXI.Text;
    constructor(){
        super();
        this.totalWinContainer = new PIXI.Container();
        let totalWinBg =  new PIXI.Sprite(Assets.get("txtBox_totalWin"));
        totalWinBg.anchor.set(0.5); 
        totalWinBg.scale.set(0.8);
        
        this.totalwinValueText = new PIXI.Text();
        this.totalwinValueText.style = {
            fontFamily: "PermanentMarker", 
            align:"center",
            fill: 'white', 
            fontSize: 30,
            fontWeight: 'bold',
            stroke:{
                color:"black",
                width:4,
                join:"round"
            },
            letterSpacing:1
        };
        this.totalwinValueText.anchor.set(0.5);
        this.totalwinValueText.text = "$0.00"
        this.totalwinValueText.y = 15;
        this.totalwinValueText.x = -5;

        this.totalwinValueText.anchor.set(0.5)
        this.totalWinContainer.addChild(totalWinBg,this.totalwinValueText);
        this.totalWinContainer.x = 100;
        this.totalWinContainer.y = -15;

        this.addChild(this.totalWinContainer); 
    }
    // inside class TotalWinButton
        public setValue(amount: number|string) {
        this.totalwinValueText.text = `${amount}`;
        }
}